/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingPageEntranceSwitchViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingPageEntranceSwitchViewQuery = { entrances: Array<{ guid: string, name: string }> };


export const SettingPageEntranceSwitchViewDocument = gql`
    query SettingPageEntranceSwitchView {
  entrances {
    guid
    name
  }
}
    `;

/**
 * __useSettingPageEntranceSwitchViewQuery__
 *
 * To run a query within a Vue component, call `useSettingPageEntranceSwitchViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingPageEntranceSwitchViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingPageEntranceSwitchViewQuery();
 */
export function useSettingPageEntranceSwitchViewQuery(options: VueApolloComposable.UseQueryOptions<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables>(SettingPageEntranceSwitchViewDocument, {}, options);
}
export function useSettingPageEntranceSwitchViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables>(SettingPageEntranceSwitchViewDocument, {}, options);
}
export type SettingPageEntranceSwitchViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingPageEntranceSwitchViewQuery, SettingPageEntranceSwitchViewQueryVariables>;